import React, { useEffect, useState } from "react";
import Anonymous from "../../../../../Assets/Images/Anonymous.svg";
import Message from "../../../../../Assets/Images/JPA Icons/message-circle.svg";
import MessageWhite from "../../../../../Assets/Images/JPA Icons/message-circle-white.svg";
import Hat from "../../../../../Assets/Images/CandidateItemIcons/Hat.svg";
import Path from "../../../../../Assets/Images/CandidateItemIcons/Path.svg";
import FrownSilver from "../../../../../Assets/Images/CandidateItemIcons/frown-silver.svg";
import Meh from "../../../../../Assets/Images/JPA Icons/meh.svg";
import MehSilver from "../../../../../Assets/Images/JPA Icons/meh-silver.svg";
import SmileWhite from "../../../../../Assets/Images/JPA Icons/smile-white.svg";
import Frown from "../../../../../Assets/Images/JPA Icons/frown.svg";
import Accepted from "../../../../../Assets/Images/JPA Icons/check-circle.svg";
import Rejected from "../../../../../Assets/Images/JPA Icons/x-circle.svg";
import { Config } from "../../../../../Config";
import axios from "axios";
import ConfirmationModal from "./ConfirmationModal";
import SkillsModal from "./SkillsModal";
import ContactInfo from "./ContactInfo";
import ConfirmResetModal from "./ConfirmResetModal";
import ConfirmDeleteCandidateModal from "./ConfirmDeleteCandidateModal";
import { NavLink } from "react-router-dom";
import { formatDate } from "../../../../../Helper_functions";
import AvailabilityIcon from "../../../../../Assets/Images/more-time.svg";
import AvailabilityModal from "./AvailabilityModal";

const CandidateItem = (props) => {
  const [Colors] = useState([
    { bg: "#B9D3FA", text: "#6DA2F2" },
    { bg: "#FFE0E0", text: "#DE8C8C" },
    { bg: "#CDFFCC", text: "#68D966" },
    { bg: "#FFFFC2", text: "#D6D65E" },
    { bg: "#E1CFFF", text: "#A781E3" },
    { bg: "#E4F7F2", text: "#71D9BB" },
    { bg: "#FFE3B3", text: "#D9B16C" },
    { bg: "#D1F0FF", text: "#60B3DB" },
  ]);
  const [ConfirmIsOpen, setConfirmIsOpen] = useState(false);
  const [ConfirmIsSkip, setConfirmIsSkip] = useState(true);
  const [ConfirmIsReject, setConfirmIsReject] = useState(false);
  const [PrevTabName, setPrevTabName] = useState("");
  const [SkillsModalIsOpen, setSkillsModalIsOpen] = useState(false);
  const [MoreInfoIsOpen, setMoreInfoIsOpen] = useState(false);
  const [ContactInfoIsOpen, setContactInfoIsOpen] = useState(false);
  const [ResetModalIsOpen, setResetModalIsOpen] = useState(false);
  const [ConfirmDeleteCandidateIsOpen, setConfirmDeleteCandidateIsOpen] =
    useState(false);
  const [AvailabilityModalIsOpen, setAvailabilityModalIsOpen] = useState(false);

  useEffect(() => {
    window.localStorage.removeItem("chat_jpaId");
    window.localStorage.removeItem("chat_recipientId");
    window.localStorage.removeItem("chat_workCiy");
    window.localStorage.removeItem("chat_title");
    window.localStorage.removeItem("chat_jpaType");
    window.localStorage.removeItem("chat_source");
    window.localStorage.removeItem("TempChatroom");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const displayStatus = () => {
    if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "PENDING"
    ) {
      return (
        <p className="item-status">{translateText("jpa_status_applied")}</p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "IN_PROGRESS"
    ) {
      return (
        <p className="item-status">
          {translateText("jpa_status_action_stage_review")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "IN_PROGRESS"
    ) {
      return (
        <p className="item-status">
          {translateText("jpa_status_action_interview")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "INVITE_SENT"
    ) {
      return (
        <p className="item-status">
          {translateText("jpa_status_action_interview")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "INVITE_ACCEPTED" &&
      props.Data.application.details[3].stage === "FINAL_DECISION" &&
      props.Data.application.details[3].subStage === "IN_PROGRESS"
    ) {
      return (
        <p className="item-status">{translateText("jpa_status_decision")}</p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "INVITE_ACCEPTED"
    ) {
      return (
        <p className="item-status">
          {translateText("jpa_status_action_interview")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "INVITE_REJECTED"
    ) {
      return (
        <p className="item-status cancelled-status">
          {translateText("jpa_status_cancelled")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "DONE" &&
      props.Data.application.details[3].stage === "ACCEPTED"
    ) {
      return (
        <p className="item-status accepted-status">
          {translateText("jpa_status_accepted")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "SKIPPED" &&
      props.Data.application.details[3].stage === "ACCEPTED"
    ) {
      return (
        <p className="item-status accepted-status">
          {translateText("jpa_status_accepted")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "DONE" &&
      props.Data.application.details[3].stage === "NOT_ACCEPTED"
    ) {
      return (
        <p className="item-status cancelled-status">
          {translateText("jpa_status_not_accepted")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "SKIPPED" &&
      props.Data.application.details[3].stage === "NOT_ACCEPTED"
    ) {
      return (
        <p className="item-status cancelled-status">
          {translateText("jpa_status_not_accepted")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "SKIPPED" &&
      props.Data.application.details[3].stage === "FINAL_DECISION" &&
      props.Data.application.details[3].subStage === "IN_PROGRESS"
    ) {
      return <p className="item-status">Decision</p>;
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "SKIPPED" &&
      props.Data.application.details[3].stage === "FINAL_DECISION" &&
      props.Data.application.details[3].subStage === "CANCELLED"
    ) {
      return (
        <p className="item-status cancelled-status">
          {translateText("jpa_status_cancelled")}
        </p>
      );
    } else if (
      props.Data.application.details[0].subStage === "DONE" &&
      props.Data.application.details[1].subStage === "DONE" &&
      props.Data.application.details[2].subStage === "CANCELLED" &&
      props.Data.application.details[3].stage === "FINAL_DECISION" &&
      props.Data.application.details[3].subStage === "CANCELLED"
    ) {
      return (
        <p className="item-status cancelled-status">
          {translateText("jpa_status_cancelled")}
        </p>
      );
    }
  };
  const displayActions = () => {
    if (props.IsAnonymous) {
      if (props.Data.application.details[1].subStage === "PENDING") {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn disabled-action-btn"
                : "big-action-btn"
            }
            onClick={() => toggleReview()}
          >
            {translateText("jpa_status_action_stage_review")}
          </button>
        );
      } else if (props.Data.application.details[1].subStage === "IN_PROGRESS") {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn interview"
              onClick={() => toggleAnonymousInterview()}
            >
              {translateText("jpa_status_action_interview")}
            </button>
            <button
              className="small-action-btn final-decision"
              onClick={() => toggleAnonymousSkipInterview()}
            >
              {translateText("jpa_action_stage_final_decision")}
            </button>
          </section>
        );
      } else if (props.Data.application.details[2].subStage === "INVITE_SENT") {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button className="small-action-btn interview disabled-action">
              {translateText("jpa_status_action_interview")}
            </button>
            <button className="small-action-btn final-decision disabled-action">
              {translateText("jpa_action_stage_final_decision")}
            </button>
          </section>
        );
      } else if (
        props.Data.application.details[2].subStage === "INVITE_ACCEPTED"
      ) {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn reject"
              onClick={() => toggleRejectCandidate()}
            >
              {translateText("jpa_action_reject")}
            </button>
            <button
              className="small-action-btn accept"
              onClick={() => toggleConfirmAccept()}
            >
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "INVITE_REJECTED"
      ) {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn cancel disabled-remove"
                : "big-action-btn cancel"
            }
            onClick={() => removeApplication()}
          >
            {translateText("jpa_action_remove_application")}
          </button>
        );
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "SKIPPED" &&
        props.Data.application.details[3].subStage === "IN_PROGRESS"
      ) {
        return (
          <section className="double-action">
            <button className="small-action-btn reject disabled-action">
              {translateText("jpa_action_reject")}
            </button>
            <button className="small-action-btn accept disabled-action">
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else if (props.Data.application.details[3].stage === "ACCEPTED") {
        return <img alt="" className="icon-status" src={Accepted} />;
      } else if (props.Data.application.details[3].stage === "NOT_ACCEPTED") {
        return <img alt="" className="icon-status" src={Rejected} />;
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "SKIPPED" &&
        props.Data.application.details[3].subStage === "CANCELLED"
      ) {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn cancel disabled-remove"
                : "big-action-btn cancel"
            }
            onClick={() => removeApplication()}
          >
            {translateText("jpa_action_remove_application")}
          </button>
        );
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "CANCELLED" &&
        props.Data.application.details[3].stage === "FINAL_DECISION" &&
        props.Data.application.details[3].subStage === "CANCELLED"
      ) {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn cancel disabled-remove"
                : "big-action-btn cancel"
            }
            onClick={() => removeApplication()}
          >
            {translateText("jpa_action_remove_application")}
          </button>
        );
      } else {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn disabled-action-btn"
                : "big-action-btn"
            }
            onClick={() => toggleReview()}
          >
            {translateText("jpa_status_action_interview")}
          </button>
        );
      }
    } else {
      if (props.Data.application.details[1].subStage === "IN_PROGRESS") {
        return (
          <section className="double-action">
            <button
              className="small-action-btn interview"
              onClick={() => toggleInterview()}
            >
              {translateText("jpa_status_action_interview")}
            </button>
            <button
              className="small-action-btn final-decision"
              onClick={() => toggleSkipInterview()}
            >
              {translateText("jpa_action_stage_final_decision")}
            </button>
          </section>
        );
      } else if (props.Data.application.details[2].subStage === "IN_PROGRESS") {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn reject"
              onClick={() => toggleRejectCandidate()}
            >
              {translateText("jpa_action_reject")}
            </button>
            <button
              className="small-action-btn accept"
              onClick={() => toggleConfirmAccept()}
            >
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "SKIPPED" &&
        props.Data.application.details[3].stage === "FINAL_DECISION"
      ) {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn reject"
              onClick={() => toggleRejectCandidate()}
            >
              {translateText("jpa_action_reject")}
            </button>
            <button
              className="small-action-btn accept"
              onClick={() => toggleConfirmAccept()}
            >
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "INVITE_ACCEPTED" &&
        props.Data.application.details[3].stage === "FINAL_DECISION"
      ) {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn reject"
              onClick={() => toggleRejectCandidate()}
            >
              {translateText("jpa_action_reject")}
            </button>
            <button
              className="small-action-btn accept"
              onClick={() => toggleConfirmAccept()}
            >
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else if (props.Data.application.details[3].stage === "ACCEPTED") {
        return (
          <React.Fragment>
            {props.Data.application.sendConfirmationReset ? (
              <p className="confirmation-info-text">
                {translateText("jpa_waiting_for_reset_confirmation")}
              </p>
            ) : (
              <img alt="" className="icon-status" src={Accepted} />
            )}
          </React.Fragment>
        );
      } else if (props.Data.application.details[3].stage === "NOT_ACCEPTED") {
        return <img alt="" className="icon-status" src={Rejected} />;
      } else if (
        props.Data.application.details[0].subStage === "DONE" &&
        props.Data.application.details[1].subStage === "DONE" &&
        props.Data.application.details[2].subStage === "INVITE_SENT" &&
        props.Data.application.details[2].stage === "INTERVIEW" &&
        props.Data.application.details[3].subStage === "PENDING"
      ) {
        return (
          <section
            className={
              props.IsAccepted
                ? "double-action disabled-actions"
                : "double-action"
            }
          >
            <button
              className="small-action-btn reject"
              onClick={() => toggleRejectCandidate()}
            >
              {translateText("jpa_action_reject")}
            </button>
            <button
              className="small-action-btn accept"
              onClick={() => toggleConfirmAccept()}
            >
              {translateText("jpa_action_accept")}
            </button>
          </section>
        );
      } else {
        return (
          <button
            className={
              props.IsAccepted
                ? "big-action-btn disabled-action-btn"
                : "big-action-btn"
            }
            onClick={() => toggleReview()}
          >
            {translateText("jpa_status_action_stage_review")}
          </button>
        );
      }
    }
  };
  const toggleRejectCandidate = () => {
    setConfirmIsSkip(false);
    setConfirmIsReject(true);
    setConfirmIsOpen(true);
  };
  const displayCandidateImage = () => {
    if (props.Data.candidate.imageThumbnailUrl === null) {
      return (
        <div
          className="avatar-holder"
          style={{
            backgroundColor: props.Data.candidate.backgroundColorCode,
            color: props.Data.candidate.textColorCode,
          }}
        >
          {props.Data.candidate.firstName.slice(0, 1).toUpperCase() +
            props.Data.candidate.lastName.slice(0, 1).toUpperCase()}
        </div>
      );
    } else {
      return (
        <div className="avatar-holder">
          <img
            className="candidate-avatar"
            alt=""
            src={props.Data.candidate.imageThumbnailUrl}
          />
        </div>
      );
    }
  };
  const toggleAnonymousSkipInterview = () => {
    setConfirmIsSkip(true);
    setConfirmIsOpen(true);
  };
  const toggleConfirmAccept = () => {
    setConfirmIsReject(false);
    setConfirmIsSkip(false);
    setConfirmIsOpen(true);
  };
  const removeApplication = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/remove-application/" +
        props.Data.application.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const toggleBookmarkCandidate = () => {
    if (
      document
        .getElementById(props.Data.id + "-bookmark")
        .classList.contains("saved-icon-nonanimated") ||
      document
        .getElementById(props.Data.id + "-bookmark")
        .classList.contains("saved-icon-animated")
    ) {
      document
        .getElementById(props.Data.id + "-bookmark")
        .classList.remove("saved-icon-nonanimated");
      document
        .getElementById(props.Data.id + "-bookmark")
        .classList.remove("saved-icon-animated");
    } else {
      document
        .getElementById(props.Data.id + "-bookmark")
        .classList.add("saved-icon-animated");
    }

    let ReqURL;
    let JPAId;
    let ApplicationId = props.Data.application.id;

    if (props.IsJob) {
      JPAId = props.JPA.position.id;
      ReqURL =
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/bookmark";
    } else if (props.IsProject) {
      JPAId = props.JPA.project.id;
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/recruitment/candidates-by-project/" +
        JPAId +
        "/bookmark";
    } else if (props.IsActivity) {
      JPAId = props.JPA.activity.id;
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/recruitment/candidates-by-activity/" +
        JPAId +
        "/bookmark";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: ApplicationId,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.FetchCandidates();
      })
      .catch((Err) => {
        console.log(Err);
        if (
          document
            .getElementById(props.Data.id + "-bookmark")
            .classList.contains("saved-icon-nonanimated") ||
          document
            .getElementById(props.Data.id + "-bookmark")
            .classList.contains("saved-icon-animated")
        ) {
          document
            .getElementById(props.Data.id + "-bookmark")
            .classList.remove("saved-icon-nonanimated");
          document
            .getElementById(props.Data.id + "-bookmark")
            .classList.remove("saved-icon-animated");
        } else {
          document
            .getElementById(props.Data.id + "-bookmark")
            .classList.add("saved-icon-animated");
        }
      });
  };
  const toggleReview = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/process";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/process";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/process";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "REVIEW",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleInterview = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/process";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/process";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/process";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "INTERVIEW",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleAnonymousInterview = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/process";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/process";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/process";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "INTERVIEW",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleSkipInterview = () => {
    setConfirmIsSkip(true);
    setConfirmIsOpen(true);
  };

  const acceptSkipNormalInterview = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/final";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/final";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/final";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "FINAL_DECISION",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setConfirmIsOpen(false);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const acceptCandidate = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/final";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/final";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/final";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "ACCEPTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.DisableItems();
        props.RefreshData();
        setConfirmIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const rejectCandidate = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL = Config.PositionServiceURL + "/api/position/recruitment/final";
    } else if (props.IsProject) {
      ReqURL = Config.ProjectServiceURL + "/api/project/recruitment/final";
    } else if (props.IsActivity) {
      ReqURL = Config.ActivityServiceURL + "/api/activity/recruitment/final";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        applicationId: props.Data.application.id,
        stage: "NOT_ACCEPTED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setConfirmIsOpen(false);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const selectSkillToDisplay = (Skills) => {
    let ShortSkills = [];
    Skills.map((Skill) => {
      if (Skill.title.length < 33) {
        ShortSkills.push(Skill.title);
      }
    });
    return ShortSkills[0];
  };
  // this function gets the id of the tab and adds related styles to the indicator and tab item
  const swapTab = (TabId, TabName) => {
    //storing the clicked tab name as prevTabName state to check for determining direction of animation(left or right)
    setPrevTabName(TabName);
    // creating an array containing the tab Ids available on this card (3 ids with candidate id + tabName);
    let TabIds = [];
    ["-skills", "-path", "-application"].map((TabName) => {
      TabIds.push(props.Data.candidate.id + TabName);
    });
    //removing the active className from all tabs first, then adding the active className to the selected
    // tab item and the indicator at the bottom
    TabIds.map((Tab) => {
      document.getElementById(Tab).classList.remove("active-tab-item");
    });
    document.getElementById(TabId).classList.add("active-tab-item");
    if (TabName === "skills") {
      //handling icon className
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.add("tab-2-active");
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.remove("tab-3-active");
      // handling content (wrapper div) className
      document
        .getElementById(props.Data.candidate.id + "-application-content")
        .classList.add("hidden");

      document
        .getElementById(props.Data.candidate.id + "-skills-content")
        .classList.remove("hidden");
      if (PrevTabName === "path") {
        document
          .getElementById(props.Data.candidate.id + "-skills-content")
          .classList.remove("translate-right");
        document
          .getElementById(props.Data.candidate.id + "-skills-content")
          .classList.add("translate-left");
      } else {
        document
          .getElementById(props.Data.candidate.id + "-skills-content")
          .classList.remove("translate-left");
        document
          .getElementById(props.Data.candidate.id + "-skills-content")
          .classList.add("translate-right");
      }
      document
        .getElementById(props.Data.candidate.id + "-path-content")
        .classList.add("hidden");
    } else if (TabName === "path") {
      //handling icon className
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.remove("tab-2-active");
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.add("tab-3-active");
      // handling content (wrapper div) className
      document
        .getElementById(props.Data.candidate.id + "-application-content")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-skills-content")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-path-content")
        .classList.remove("hidden");
      document
        .getElementById(props.Data.candidate.id + "-path-content")
        .classList.add("translate-right");
    } else {
      //handling icon className
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.remove("tab-2-active");
      document
        .getElementById(props.Data.candidate.id + "-tab-indicator")
        .classList.remove("tab-3-active");
      // handling content (wrapper div) className
      document
        .getElementById(props.Data.candidate.id + "-application-content")
        .classList.remove("hidden");
      document
        .getElementById(props.Data.candidate.id + "-skills-content")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-path-content")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-application-content")
        .classList.add("translate-left");
    }
  };

  const displayPathItems = (Candidate) => {
    if (Candidate.path !== null) {
      let Paths = Candidate.path.split(",");
      var Path1 = Paths[0];
      var Path2 = Paths[1];

      if (Path1 === "income") {
        Path1 = "Improve Income";
      } else if (Path1 === "career") {
        Path1 = "Next level career";
      } else if (Path1 === "skills") {
        Path1 = "Improve Skills";
      } else if (Path1 === "projects") {
        Path1 = "Cool projects";
      }
      if (Path2 === "income") {
        Path2 = "Improve Income";
      } else if (Path2 === "career") {
        Path2 = "Next level career";
      } else if (Path2 === "skills") {
        Path2 = "Improve Skills";
      } else if (Path2 === "projects") {
        Path2 = "Cool projects";
      }
      return (
        <React.Fragment>
          {Path1 !== undefined ? (
            <span className="path-item">{Path1}</span>
          ) : null}
          {Path2 !== undefined ? (
            <span className="path-item">{Path2}</span>
          ) : null}
        </React.Fragment>
      );
    } else {
      return <p className="non-margined-not-available">{translateText("not_available")}</p>;
    }
  };

  const handleSkills = () => {
    let Skills = [];
    props.Data.candidate.topSkills.map((Skill) => {
      Skills.push(Skill.title);
    });
    return Skills;
  };
  const toggleContactInfo = () => {
    setMoreInfoIsOpen(false);
    setContactInfoIsOpen(true);
  };
  const toggleAvailabilityModal = () => {
    setMoreInfoIsOpen(false);
    setAvailabilityModalIsOpen(true);
  };
  const toggleResetApplication = () => {
    setMoreInfoIsOpen(false);
    setResetModalIsOpen(true);
  };
  const acceptReset = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        Config.PositionServiceURL +
        "/api/position/recruitment/reset-application/";
    } else if (props.IsProject) {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/recruitment/reset-application/";
    } else if (props.IsActivity) {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/recruitment/reset-application/";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL + props.Data.application.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: props.Data.application.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
        setMoreInfoIsOpen(false);
        setResetModalIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const handleCandidateIdentityDisplay = () => {
    if (props.Data.candidate.lastName === null) {
      return "Anonymous";
    } else {
      return (
        props.Data.candidate.firstName + " " + props.Data.candidate.lastName
      );
    }
  };
  const toggleDeleteCandidate = () => {
    setMoreInfoIsOpen(false);
    setConfirmDeleteCandidateIsOpen(true);
  };
  const AcceptDeleteCandidate = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/reject-and-remove-candidate/";
    } else if (props.IsProject) {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/recruitment/candidates-by-project/reject-and-remove-candidate/";
    } else if (props.IsActivity) {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/recruitment/candidates-by-activity/reject-and-remove-candidate/";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL + props.Data.application.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: props.Data.application.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
        setConfirmDeleteCandidateIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const restoreApplication = () => {
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        Config.PositionServiceURL +
        "/api/position/recruitment/archive-candidates-by-position/";
    } else if (props.IsProject) {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/recruitment/archive-candidates-by-project/";
    } else if (props.IsActivity) {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/recruitment/archive-candidates-by-activity/";
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ReqURL +
        props.Data.application.id +
        "/restore-candidate",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        applicationId: props.Data.application.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const toggleChat = () => {
    let SelectedJPA = props.JPA;
    let JPAId;
    let JPATitle;
    let WorkCity;
    let JPAType;
    if (props.IsProject) {
      JPATitle = SelectedJPA.project.title;
      WorkCity = SelectedJPA.project.workCity;
      JPAType = "project";
      JPAId = SelectedJPA.project.id;
    } else if (props.IsActivity) {
      JPATitle = SelectedJPA.activity.title;
      WorkCity = SelectedJPA.activity.workCity;
      JPAType = "activity";
      JPAId = SelectedJPA.activity.id;
    } else {
      JPATitle = SelectedJPA.position.title;
      WorkCity = SelectedJPA.position.workCity;
      JPAType = "position";
      JPAId = SelectedJPA.position.id;
    }

    window.localStorage.setItem("chat_jpaId", JPAId);
    window.localStorage.setItem("chat_recipientId", props.Data.candidate.id);
    window.localStorage.setItem("chat_workCiy", WorkCity);
    window.localStorage.setItem("chat_title", JPATitle);
    window.localStorage.setItem("chat_jpaType", JPAType);
    window.localStorage.setItem("chat_source", "CANDIDATE");

    setTimeout(() => {
      document.getElementById("communication-toggle").click();
    }, 200);
  };

  const displayHigherEducation = () => {
    let Education =
        props.Data.candidate.higherEducation.major +
        ", " +
        props.Data.candidate.higherEducation.degree;
    if (Education.length <= 34) {
      if (window.innerWidth <= 1024 && window.innerWidth >= 600) {
        Education =
            Education.length <= 28 ? Education : Education.slice(0, 25) + "...";
      }
      return <p className="tab-info">{Education}</p>;
    } else {
      let Shortened = Education.slice(0, 30) + "...";
      if (window.innerWidth <= 1024 && window.innerWidth >= 600)
        Shortened = Education.slice(0, 25) + "...";
      return (
          <p className="tab-info">
            {Shortened}
            <p className="popup-text">{Education}</p>
          </p>
      );
    }
  };

  return (
    <div className="recruiter-jpa-item">
      <NavLink hidden to="/communication" id="communication-toggle"></NavLink>
      {ConfirmIsOpen ? (
        <ConfirmationModal
          Close={() => setConfirmIsOpen(false)}
          AcceptSkipInterview={() => acceptSkipNormalInterview()}
          Data={props.Data}
          AnonymousIcon={Anonymous}
          Color={Colors[Math.floor(Math.random() * Colors.length)]}
          ConfirmIsSkip={ConfirmIsSkip}
          AcceptCandidate={() => acceptCandidate()}
          AcceptSkipNormalInterview={() => acceptSkipNormalInterview()}
          RejectCandidate={() => rejectCandidate()}
          ConfirmIsReject={ConfirmIsReject}
          LangData={props.LangData}
        />
      ) : null}
      {SkillsModalIsOpen ? (
        <SkillsModal
          Close={() => setSkillsModalIsOpen(false)}
          Skills={handleSkills()}
          Title={handleCandidateIdentityDisplay()}
          Location={props.Data.candidate.currentPositionTitle}
          IsCandidateSkills={true}
          LangData={props.LangData}
        />
      ) : null}
      {ResetModalIsOpen ? (
        <ConfirmResetModal
          AcceptReset={() => acceptReset()}
          Close={() => setResetModalIsOpen(false)}
          Data={props.Data}
          AnonymousIcon={Anonymous}
          LangData={props.LangData}
        />
      ) : null}
      {ConfirmDeleteCandidateIsOpen ? (
        <ConfirmDeleteCandidateModal
          AcceptDelete={() => AcceptDeleteCandidate()}
          Close={() => setConfirmDeleteCandidateIsOpen(false)}
          Data={props.Data}
          AnonymousIcon={Anonymous}
          LangData={props.LangData}
        />
      ) : null}
      {ContactInfoIsOpen ? (
        <ContactInfo
          Close={() => setContactInfoIsOpen(false)}
          Candidate={props.Data.candidate}
          LangData={props.LangData}
        />
      ) : null}
      {AvailabilityModalIsOpen ? (
        <AvailabilityModal
          Close={() => setAvailabilityModalIsOpen(false)}
          Candidate={props.Data.candidate}
          Availability={props.Data.application.availability}
          LangData={props.LangData}
          Icon={AvailabilityIcon}
          ApplicationType={props.Data.application.type}
        />
      ) : null}
      {displayStatus()}
      <button className="more-info" onClick={() => setMoreInfoIsOpen(true)}>
        <i className="feather-more-vertical"></i>
      </button>
      <React.Fragment>
        {MoreInfoIsOpen ? (
          <React.Fragment>
            <div
              className="outline"
              onClick={() => setMoreInfoIsOpen(false)}
            ></div>
            {props.IsDeleted ? (
              <div className="context-menu small-menu">
                {props.Data.candidate.revealIdentity ? (
                  <section
                    className="menu-item"
                    onClick={() => toggleContactInfo()}
                  >
                    <i className="feather-message-circle"></i>
                    <p>{translateText("contact_info")}</p>
                  </section>
                ) : (
                  <section className="menu-item disabled-menu-item">
                    <i className="feather-message-circle"></i>
                    <p>{translateText("contact_info")}</p>
                  </section>
                )}
                <section
                  className="menu-item"
                  onClick={() => toggleContactInfo()}
                >
                  <i className="feather-message-circle"></i>
                  <p>{translateText("resource_availability")}</p>
                </section>
                <section
                  className="menu-item"
                  onClick={() => restoreApplication()}
                >
                  <i className="feather-corner-down-left"></i>
                  <p>Restore application</p>
                </section>
              </div>
            ) : (
              <div className="context-menu">
                {props.Data.candidate.revealIdentity ? (
                  <section
                    className="menu-item"
                    onClick={() => toggleContactInfo()}
                  >
                    <i className="feather-message-circle"></i>
                    <p>{translateText("contact_info")}</p>
                  </section>
                ) : (
                  <section className="menu-item disabled-menu-item">
                    <i className="feather-message-circle"></i>
                    <p>{translateText("contact_info")}</p>
                  </section>
                )}
                <section
                  className="menu-item"
                  onClick={() => toggleAvailabilityModal()}
                >
                  <img alt="" src={AvailabilityIcon} />
                  <p>{translateText("resource_availability")}</p>
                </section>
                {props.Data.application.details[1].subStage === "PENDING" ||
                props.Data.application.details[1].subStage === "IN_PROGRESS" ||
                props.Data.application.sendConfirmationReset ? (
                  <section className="menu-item disabled-menu-item">
                    <i className="feather-refresh-ccw"></i>
                    <p>{translateText("jpa_actions_reset_application")}</p>
                  </section>
                ) : (
                  <section
                    className="menu-item menu-item-red"
                    onClick={() => toggleResetApplication()}
                  >
                    <i className="feather-refresh-ccw"></i>
                    <p>{translateText("jpa_actions_reset_application")}</p>
                  </section>
                )}
                {props.Data.application.details[3].stage === "ACCEPTED" &&
                props.Data.application.details[3].subStage === "DONE" ? (
                  <section className="menu-item disabled-menu-item">
                    <i className="feather-trash-2"></i>
                    <p>{translateText("jpa_actions_delete_candidate")}</p>
                  </section>
                ) : (
                  <section
                    className="menu-item menu-item-red"
                    onClick={() => toggleDeleteCandidate()}
                  >
                    <i className="feather-trash-2"></i>
                    <p>{translateText("jpa_actions_delete_candidate")}</p>
                  </section>
                )}
              </div>
            )}
          </React.Fragment>
        ) : null}
      </React.Fragment>
      {props.IsDeleted ? null : (
        <button
          className={
            props.Data.bookmarked
              ? "bookmark-btn saved-icon-nonanimated"
              : "bookmark-btn"
          }
          onClick={() => toggleBookmarkCandidate()}
          id={props.Data.id + "-bookmark"}
        ></button>
      )}
      {props.IsAnonymous ? (
        <button
          className="communication-connector disabled-connector"
          onClick={() => null}
        ></button>
      ) : (
        <button
          className="communication-connector"
          onClick={() => toggleChat()}
        ></button>
      )}
      <section className="candidate-info">
        {props.IsAnonymous ? (
          <div className="avatar-holder anonymous-image-holder">
            <img alt="anonymous" src={Anonymous} />
          </div>
        ) : (
          <React.Fragment>{displayCandidateImage()}</React.Fragment>
        )}
        <p className="candidate-name">
          {props.IsAnonymous
            ? "Anonymous"
            : props.Data.candidate.firstName +
              " " +
              props.Data.candidate.lastName}
        </p>
        <React.Fragment>
          {props.IsAnonymous ? (
            <p className="candidate-position">{translateText("unknown")}</p>
          ) : (
            <React.Fragment>
              {props.Data.candidate.currentPositionTitle ===
              <p className="candidate-position"></p> ? null : (
                <p className="candidate-position">
                  {props.Data.candidate.currentPositionTitle}
                </p>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      </section>
      <section className="candidate-tabs">
        <i
          onClick={() =>
            swapTab(props.Data.candidate.id + "-application", "application")
          }
          id={props.Data.candidate.id + "-application"}
          className="feather-briefcase active-tab-item"
        ></i>
        <i
          onClick={() => swapTab(props.Data.candidate.id + "-skills", "skills")}
          id={props.Data.candidate.id + "-skills"}
          className="feather-star"
        ></i>
        <i
          onClick={() => swapTab(props.Data.candidate.id + "-path", "path")}
          id={props.Data.candidate.id + "-path"}
          className="feather-flag"
        ></i>
        <span
          id={props.Data.candidate.id + "-tab-indicator"}
          className="tab-indicator"
        ></span>
      </section>
      {/* the content of the tabs store in a parent wrapper for applying animations */}
      <React.Fragment>
        <div
          id={props.Data.candidate.id + "-application-content"}
          className="application-content"
        >
          <section className="steps">
            <span className="bg-line"></span>
            {props.Data.application.details[1].subStage === "IN_PROGRESS" ? (
              <div className="step-item step-item-active">
                <React.Fragment>
                  {props.UserInfo.imageThumbnailUrl === null ? (
                    <span className="step-icon item-icon-active">
                      <span className="reviewer-placeholder">
                        <p>
                          {props.UserInfo.firstName.slice(0, 1).toUpperCase() +
                            props.UserInfo.lastName.slice(0, 1).toUpperCase()}
                        </p>
                      </span>
                    </span>
                  ) : (
                    <img
                      alt="you"
                      className="reviewer-avatar"
                      src={props.UserInfo.imageThumbnailUrl}
                    />
                  )}
                </React.Fragment>

                <p className="step-name">
                  {translateText("jpa_status_action_stage_review")}
                </p>
                <p className="step-status">{translateText("in_progress")}</p>
              </div>
            ) : (
              <div className="step-item">
                {props.Data.application.details[1].subStage !== "DONE" &&
                props.Data.application.details[2].subStage !== "DONE" &&
                props.Data.application.details[3].subStage !== "DONE" ? (
                  <span className="step-icon">
                    <React.Fragment>
                      {props.UserInfo.imageThumbnailUrl === null ? (
                        <span className="step-icon">
                          <span className="reviewer-placeholder">
                            <p>
                              {props.UserInfo.firstName
                                .slice(0, 1)
                                .toUpperCase() +
                                props.UserInfo.lastName
                                  .slice(0, 1)
                                  .toUpperCase()}
                            </p>
                          </span>
                        </span>
                      ) : (
                        <img
                          alt="you"
                          className="reviewer-avatar"
                          src={props.UserInfo.imageThumbnailUrl}
                        />
                      )}
                    </React.Fragment>
                  </span>
                ) : (
                  <React.Fragment>
                    {props.UserInfo.imageThumbnailUrl === null ? (
                      <span className="step-icon">
                        <span className="reviewer-placeholder">
                          <p>
                            {props.UserInfo.firstName
                              .slice(0, 1)
                              .toUpperCase() +
                              props.UserInfo.lastName.slice(0, 1).toUpperCase()}
                          </p>
                        </span>
                      </span>
                    ) : (
                      <img
                        alt="you"
                        className="reviewer-avatar"
                        src={props.UserInfo.imageThumbnailUrl}
                      />
                    )}
                  </React.Fragment>
                )}
                {props.Data.application.details[1].subStage === "DONE" ? (
                  <p className="step-name">{translateText("reviewed")}</p>
                ) : (
                  <p className="step-name">
                    {translateText("jpa_status_action_stage_review")}
                  </p>
                )}
                {props.Data.application.details[1].subStage === "DONE" ? (
                  <p className="step-status">{translateText("done")}</p>
                ) : (
                  <p className="step-status">{translateText("pending")}</p>
                )}
              </div>
            )}
            {props.Data.application.details[2].subStage === "IN_PROGRESS" ? (
              <div className="step-item step-item-active">
                <span className="step-icon item-icon-active">
                  <img alt="" src={MessageWhite} />
                </span>
                <p className="step-name">
                  {translateText("jpa_status_action_interview")}
                </p>
                <p className="step-status">{translateText("in_progress")}</p>
              </div>
            ) : (
              <div className="step-item">
                <span
                  className={
                    props.Data.application.details[2].subStage ===
                      "INVITE_SENT" ||
                    (props.Data.application.details[2].subStage ===
                      "INVITE_ACCEPTED" &&
                      props.Data.application.details[3].subStage !==
                        "IN_PROGRESS") ||
                    props.Data.application.details[2].subStage ===
                      "INVITE_REJECTED" ||
                    (props.Data.application.details[0].subStage === "DONE" &&
                      props.Data.application.details[1].subStage === "DONE" &&
                      props.Data.application.details[2].subStage ===
                        "CANCELLED" &&
                      props.Data.application.details[3].stage ===
                        "FINAL_DECISION" &&
                      props.Data.application.details[3].subStage ===
                        "CANCELLED")
                      ? "step-icon item-icon-active"
                      : "step-icon"
                  }
                >
                  {props.Data.application.details[2].subStage ===
                    "INVITE_SENT" ||
                  (props.Data.application.details[2].subStage ===
                    "INVITE_ACCEPTED" &&
                    props.Data.application.details[3].subStage !==
                      "IN_PROGRESS") ||
                  props.Data.application.details[2].subStage ===
                    "INVITE_REJECTED" ||
                  (props.Data.application.details[0].subStage === "DONE" &&
                    props.Data.application.details[1].subStage === "DONE" &&
                    props.Data.application.details[2].subStage ===
                      "CANCELLED" &&
                    props.Data.application.details[3].stage ===
                      "FINAL_DECISION" &&
                    props.Data.application.details[3].subStage ===
                      "CANCELLED") ? (
                    <img alt="" src={MessageWhite} />
                  ) : (
                    <img alt="" src={Message} />
                  )}
                </span>
                {props.Data.application.details[2].subStage === "DONE" ? (
                  <p className="step-name">{translateText("interviewed")}</p>
                ) : (
                  <p className="step-name">
                    {translateText("jpa_status_action_interview")}
                  </p>
                )}
                {props.Data.application.details[2].subStage === "DONE" ? (
                  <p className="step-status">{translateText("done")}</p>
                ) : (
                  <React.Fragment>
                    {props.Data.application.details[2].subStage ===
                    "INVITE_SENT" ? (
                      <p className="step-status">
                        {translateText("invite_sent")}
                      </p>
                    ) : (
                      <React.Fragment>
                        {props.Data.application.details[2].subStage ===
                        "SKIPPED" ? (
                          <p className="step-status">
                            {translateText("skipped")}
                          </p>
                        ) : (
                          <React.Fragment>
                            {props.Data.application.details[2].subStage ===
                              "INVITE_ACCEPTED" &&
                            props.Data.application.details[3].subStage !==
                              "IN_PROGRESS" ? (
                              <p className="step-status">
                                {translateText("in_progress")}
                              </p>
                            ) : (
                              <React.Fragment>
                                {props.Data.application.details[3].subStage ===
                                "IN_PROGRESS" ? (
                                  <p className="step-status">
                                    {translateText("skipped")}
                                  </p>
                                ) : (
                                  <React.Fragment>
                                    {props.Data.application.details[0]
                                      .subStage === "DONE" &&
                                    props.Data.application.details[1]
                                      .subStage === "DONE" &&
                                    props.Data.application.details[2]
                                      .subStage === "CANCELLED" &&
                                    props.Data.application.details[3].stage ===
                                      "FINAL_DECISION" &&
                                    props.Data.application.details[3]
                                      .subStage === "CANCELLED" ? (
                                      <p className="step-status">
                                        {translateText("jpa_status_cancelled")}
                                      </p>
                                    ) : (
                                      <p className="step-status">
                                        {translateText("pending")}
                                      </p>
                                    )}
                                  </React.Fragment>
                                )}
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </div>
            )}
            {props.Data.application.details[3].subStage === "DONE" &&
            props.Data.application.details[2].subStage !== "SKIPPED" ? (
              <div className="step-item">
                <span className="step-icon item-icon-active">
                  {props.Data.application.details[3].stage === "ACCEPTED" ? (
                    <img alt="" src={SmileWhite} />
                  ) : (
                    <img alt="" src={Frown} />
                  )}
                </span>
                {props.Data.application.details[3].stage === "ACCEPTED" ? (
                  <p className="step-name">
                    {translateText("jpa_status_accepted")}
                  </p>
                ) : (
                  <p className="step-name final-decision-label">
                    {translateText("jpa_status_not_accepted")}
                  </p>
                )}
                {props.Data.application.details[3].subStage === "DONE" ? (
                  <p className="step-status">
                    {formatDate(
                      new Date(props.Data.application.details[3].date).getTime()
                    )}
                  </p>
                ) : (
                  <p className="step-status">{translateText("pending")}</p>
                )}
              </div>
            ) : (
              <React.Fragment>
                {props.Data.application.details[2].subStage === "SKIPPED" ? (
                  <div className="step-item">
                    <span className="step-icon item-icon-active">
                      {props.Data.application.details[3].subStage ===
                      "CANCELLED" ? (
                        <img alt="" src={Frown} />
                      ) : (
                        <React.Fragment>
                          {props.Data.application.details[3].subStage ===
                            "IN_PROGRESS" &&
                          props.Data.application.details[3].stage ===
                            "FINAL_DECISION" &&
                          props.Data.application.type !== "DEFAULT" &&
                          props.Data.application.directFinalDecision ? (
                            <img alt="" src={Meh} />
                          ) : (
                            <React.Fragment>
                              {props.Data.application.details[3].stage ===
                              "ACCEPTED" ? (
                                <img alt="" src={SmileWhite} />
                              ) : (
                                <img
                                  alt=""
                                  src={
                                    props.Data.application.details[3]
                                      .subStage === "IN_PROGRESS" &&
                                    props.Data.application.details[2]
                                      .subStage === "SKIPPED" &&
                                    props.Data.application.details[1]
                                      .subStage === "DONE" &&
                                    props.Data.application.type === "DEFAULT"
                                      ? Meh
                                      : Frown
                                  }
                                />
                              )}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </span>
                    {props.Data.application.details[3].stage ===
                      "NOT_ACCEPTED" &&
                    props.Data.application.details[3].subStage === "DONE" ? (
                      <p className="step-name final-decision-label">
                        {translateText("jpa_status_not_accepted")}
                      </p>
                    ) : (
                      <React.Fragment>
                        {props.Data.application.details[2].stage ===
                          "SKIPPED" &&
                        props.Data.application.details[3].subStage ===
                          "IN_PROGRESS" ? (
                          <p className="step-name">Accepted</p>
                        ) : (
                          <React.Fragment>
                            {props.Data.application.details[1].subStage ===
                              "DONE" &&
                            props.Data.application.details[2].subStage ===
                              "SKIPPED" &&
                            props.Data.application.details[3].stage ===
                              "ACCEPTED" &&
                            props.Data.application.details[3].subStage ===
                              "DONE" ? (
                              <p className="step-name">
                                {translateText("jpa_status_accepted")}
                              </p>
                            ) : (
                              <p className="step-name final-decision-label">
                                {translateText(
                                  "jpa_action_stage_final_decision"
                                )}
                              </p>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                    {props.Data.application.details[3].subStage ===
                    "IN_PROGRESS" ? (
                      <p className="step-status">
                        {translateText("in_progress")}
                      </p>
                    ) : (
                      <React.Fragment>
                        {props.Data.application.details[3].stage ===
                          "ACCEPTED" ||
                        props.Data.application.details[3].stage ===
                          "NOT_ACCEPTED" ? (
                          <p className="step-status">
                            {formatDate(
                              new Date(
                                props.Data.application.details[3].date
                              ).getTime()
                            )}
                          </p>
                        ) : (
                          <React.Fragment>
                            {props.Data.application.details[3].subStage ===
                            "CANCELLED" ? (
                              <p className="step-status">
                                {translateText("jpa_status_cancelled")}
                              </p>
                            ) : (
                              <p className="step-status">
                                {translateText("pending")}
                              </p>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                ) : (
                  <React.Fragment>
                    {props.Data.application.details[3].subStage ===
                    "IN_PROGRESS" ? (
                      <div className="step-item">
                        <span className="step-icon item-icon-active">
                          <img alt="" src={SmileWhite} />
                        </span>
                        <p className="step-name final-decision-label">
                          {translateText("jpa_action_stage_final_decision")}
                        </p>
                        <p className="step-status">
                          {translateText("in_progress")}
                        </p>
                      </div>
                    ) : (
                      <div className="step-item">
                        <span className="step-icon">
                          {props.Data.application.details[2].subStage ===
                            "CANCELLED" ||
                          props.Data.application.details[3].subStage ===
                            "CANCELLED" ? (
                            <img alt="" src={FrownSilver} />
                          ) : (
                            <img alt="" src={MehSilver} />
                          )}
                        </span>
                        <p className="step-name final-decision-label">
                          {translateText("jpa_action_stage_final_decision")}
                        </p>
                        {props.Data.application.details[0].subStage ===
                          "DONE" &&
                        props.Data.application.details[1].subStage === "DONE" &&
                        props.Data.application.details[2].subStage ===
                          "CANCELLED" &&
                        props.Data.application.details[3].stage ===
                          "FINAL_DECISION" &&
                        props.Data.application.details[3].subStage ===
                          "CANCELLED" ? (
                          <p className="step-status">
                            {translateText("jpa_status_cancelled")}
                          </p>
                        ) : (
                          <p className="step-status">
                            {translateText("pending")}
                          </p>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </section>
          <section className="candidate-actions">
            <React.Fragment>{displayActions()}</React.Fragment>
          </section>
        </div>
        <div
          id={props.Data.candidate.id + "-skills-content"}
          className="skills-content hidden"
        >
          <div className="iconed-row">
            <i className="feather-star"></i>
            <section className="row-content">
              <p className="row-label">{translateText("top_5_skills")}</p>
              <section className="skills">
                {props.Data.candidate.topSkills !== null ? (
                  <React.Fragment>
                    <span className="skill-item">
                      {selectSkillToDisplay(props.Data.candidate.topSkills)}
                    </span>
                    <span
                      className="more-skills"
                      onClick={() => setSkillsModalIsOpen(true)}
                    >
                      <i className="feather-more-vertical"></i>
                    </span>
                  </React.Fragment>
                ) : null}
              </section>
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-award"></i>
            <section className="row-content">
              <p className="row-label">
                {translateText("years_of_experience")}
              </p>
              <p className="tab-info">
                {props.Data.candidate.yearsOfExperience}
              </p>
            </section>
          </div>
          <div className="iconed-row">
            <img src={Hat} />
            <section className="row-content">
              <section className="row-content">
                <p className="row-label">{translateText("higher_education")}</p>
                {props.Data.candidate.higherEducation !== null ? (
                    <React.Fragment>{displayHigherEducation()}</React.Fragment>
                ) : (
                    <p className="not-available">
                      {translateText("not_available")}
                    </p>
                )}
              </section>
            </section>
          </div>
        </div>
        <div
          id={props.Data.candidate.id + "-path-content"}
          className="path-content hidden"
        >
          <div className="iconed-row">
            <img src={Path} />
            <section className="row-content">
              <p className="row-label">{translateText("wizard_your_path")}</p>
              <section className="skills paths">
                {displayPathItems(props.Data.candidate)}
              </section>
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-globe"></i>
            <section className="row-content">
              <p className="row-label">{translateText("language")}</p>
              {props.Data.candidate.language === null ? null : (
                <p className="tab-info">
                  {props.Data.candidate.language.toString()}
                </p>
              )}
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-map-pin"></i>
            <section className="row-content">
              <section className="row-content">
                <p className="row-label">{translateText("home_city")}</p>
                <p className="tab-info">{props.Data.candidate.homeCity}</p>
              </section>
            </section>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
};

export default CandidateItem;
